import Vue from 'vue';
import Vuex from 'vuex';
import { TENANT_ID_KEY, TOKEN_KEY } from '@/config';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    userInfo: JSON.parse(localStorage.getItem('userInfo') || '{}'),
    roleList: JSON.parse(localStorage.getItem('roles') || '[]'),
    token: localStorage.getItem(TOKEN_KEY) || '',
    tenantId: localStorage.getItem(TENANT_ID_KEY) || '',
    shopId: localStorage.getItem('shopId') || '',
    shopList: JSON.parse(localStorage.getItem('shopList') || '[]'),
  },
  mutations: {
    SET_USER(state, user) {
      state.userInfo = user;
      localStorage.setItem('userInfo', JSON.stringify(user));
    },
    SET_ROLES(state, roles) {
      state.roleList = roles;
      localStorage.setItem('roles', JSON.stringify(roles));
    },
    SET_SHOP_ID(state, shop_id) {
      state.shopId = shop_id;
      localStorage.setItem('shopId', shop_id);
    },
    SET_TOKEN(state, token) {
      state.token = token;
      localStorage.setItem(TOKEN_KEY, token);
    },
    SET_TENANT_ID(state, tenantId) {
      state.tenantId = tenantId;
      localStorage.setItem(TENANT_ID_KEY, tenantId);
    },
    SET_SHOP_LIST(state, shopList) {
      if (!shopList) return;
      state.shopList = shopList;
      localStorage.setItem('shopList', JSON.stringify(shopList));
    },
    LOGOUT(state) {
      state.userInfo = {};
      state.token = '';
      state.roleList = [];
      state.tenantId = '';
      localStorage.clear();
    },
  },
  getters: {
    isLoggedIn: (state) => !!state.token,
    roles: (state) =>
      state.shopList
        .find((item) => item.shopId === state.shopId)
        ?.roleAliases?.filter(Boolean) || [],
    currentRole: (state) =>
      state.shopList
        .find((item) => item.shopId === state.shopId)
        ?.roleNames?.filter(Boolean)
        ?.join('、') || '',
    currentRoles: (state) =>
      state.shopList
        .find((item) => item.shopId === state.shopId)
        ?.roleAliases?.filter(Boolean) || [],
    currentShop: (state) =>
      state.shopList.find((item) => item.shopId === state.shopId),
    tenantName: (state) => state.userInfo.tenantName || '',
    storeId: (state) => state.userInfo.storeId,
  },
});
